import * as React from 'react';
import { IListItem } from '../../common/classes/list-item';

export type IProviderListItemProps = IListItem;

function openDialog(event) {
    let targetId = event.target.getAttribute('data-modal-name');
    let dialog = (window as any)[targetId];
    if (dialog) {
        dialog.show();
    }
}

export const LocationListItem: React.StatelessComponent<IProviderListItemProps> = props => {
    return (
        <li className={props.networks && props.networks[0] ? "adage-profile-item adage-profile-location-item adage-search-item adage-search-item-highlight" : "adage-profile-item adage-profile-location-item adage-search-item" }>
            <div className="adage-profile-item-inner">
                <div className="adage-profile-item-info">
                    <div className="adage-profile">
                        <div className="adage-profile-details">
                            <div className="adage-profile-name">
                                <div className="adage-profile-media">
                                    <a href={props.pageUrl} className="adage-profile-media-inner" aria-hidden="true" role="presentation">
                                        {props.picture
                                            ?
                                                <img src={props.picture} alt="" />
                                            :
                                                <svg className="svg-icon adage-profile-media-location" aria-hidden="true" focusable="false">
                                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-location-placeholder" />
                                                </svg>
                                        }
                                    </a>
                                </div>

                                <div className="adage-profile-name-content">
                                    <h4 className="adage-profile-name-heading">
                                        <a href={props.pageUrl}>{props.hasOffice1DisplayName ? props.nameString : props.name}</a>
                                    </h4>

                                    {props.networkIcons && props.networkIcons[0] ?
                                        <ul className="adage-profile-icons-list">
                                            {props.networkIcons.map((icon, idx) => {
                                                return (
                                                    <li key={idx}>
                                                        <button data-modal-name={icon.networkName.replace(" ", "") + "Modal"} onClick={openDialog} className="btn-text">
                                                            <svg className="svg-icon" aria-hidden="true" focusable="false" role="presentation">
                                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#icon-${icon.selectedIcon}`}></use>
                                                            </svg>
                                                            {icon.networkName}
                                                        </button>
                                                    </li>
                                                )
                                            })}
                                        </ul> : null
                                    }

                                    {props.address1 ?
                                        <div className="adage-profile-address">
                                            <p>
                                                {props.address1}<br />
                                                {props.address2 ? props.address2 : null}
                                                {props.address2 ? <br /> : null}
                                                {props.addressCity}, {props.addressState} {props.addressZip}
                                            </p>
                                        </div>
                                    :
                                        null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="adage-profile-item-aside">
                    <div className="adage-profile-content">
                        <h5 className="adage-profile-content-heading">Request an appointment</h5>

                        <div className="adage-profile-content-btns">
                            <a className="btn adage-profile-content-phone" href={"tel:" + props.phoneNumber}>{props.phoneNumber}</a>
                            {
                                props.ctaText && props.ctaUrl ? <a href={props.ctaUrl}>{props.ctaText}</a> : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </li>
    )
}